import React from "react";
import {TextAlpha} from "./TextAlpha";

export function InputNumberAlpha(props) {

    return (
        <div className={props.containerClassName}>

            <input type={"number"}
                   disabled={props.disabled}
                   name={props.name}
                   className={props.inputClassName}
                   placeholder={props.placeholder}
                   onChange={props.onChange}
                   value={props.value}
                   max={props.max}
                   min={props.min}
            />
            <TextAlpha text={props.label} className={props.labelClassName}/>

        </div>
    )
}
